import type { ReactNode } from 'react';
import { ExternalLink, isWebUrl } from './ExternalLink';
import { Muted } from './Muted';
import styles from './ui.module.css';

/**
 * Внешний адрес в карточке: источник способности.
 *
 * Набран мельче описания — он справочный, а карточку читают ради текста.
 * Каркас — `ExternalLink` (`href`, фокус, цвет акцента), своя только
 * типографика. Раньше на то же место работал селектор по тегу внутри карточки
 * (`.propExtra a`): он красил любую ссылку, какая туда попадёт.
 *
 * Кегль задан ОБЁРТКЕ, а не самой ссылке: у вкуишного `Link` объявлено
 * `font-size: inherit` с той же специфичностью, что и у нашего класса, и
 * побеждает он — его таблица подключается позже. Наследованием же он берёт
 * ровно то, что дала обёртка.
 *
 * Адрес пишет игрок, а React 18 `javascript:` в `href` не режет: всё, что не
 * http(s), остаётся текстом.
 */
export function SourceLink({ href, children }: { href: string; children: ReactNode }) {
  const web = isWebUrl(href);
  if (!web) return <Muted>{children}</Muted>;

  return (
    <span className={styles.sourceLink}>
      <ExternalLink href={href}>{children}</ExternalLink>
    </span>
  );
}
